(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beach-ball-hunt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var lastTrigger = null;

    function root() { return document.querySelector('[data-bbh]'); }

    function claim() {
      var wrapper = root();
      if (!wrapper || !wrapper.hasAttribute('data-bbh-once')) return;
      try {
        localStorage.setItem(wrapper.dataset.bbhKey, new Date().toISOString());
      } catch (e) {}
    }

    function open(trigger) {
      var modal = document.querySelector('[data-bbh-modal]');
      if (!modal) return;
      lastTrigger = trigger;
      claim();
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var focusTarget = modal.querySelector('[data-bbh-copy]') || modal.querySelector('[data-bbh-close]');
      if (focusTarget) focusTarget.focus();
    }

    function close() {
      var modal = document.querySelector('[data-bbh-modal]:not([hidden])');
      if (!modal) return;
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastTrigger && document.body.contains(lastTrigger)) lastTrigger.focus();

      var wrapper = root();
      if (wrapper && wrapper.hasAttribute('data-bbh-once')) {
        document.documentElement.classList.add('bbh-claimed');
      }
    }

    function anchor() {
      document.querySelectorAll('[data-bbh-card]').forEach(function (ball) {
        var host = ball.parentElement;
        if (!host || host.dataset.bbhHost === 'true') return;
        host.dataset.bbhHost = 'true';
        if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      });
    }

    document.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-bbh-open]');
      if (openBtn) {
        event.preventDefault();
        event.stopPropagation();
        open(openBtn);
        return;
      }

      if (event.target.closest('[data-bbh-close]') || event.target.matches('[data-bbh-modal]')) {
        close();
        return;
      }

      var copyBtn = event.target.closest('[data-bbh-copy]');
      if (!copyBtn) return;

      var code = document.querySelector('[data-bbh-code]').textContent.trim();
      var idle = copyBtn.dataset.label || 'Copy code';
      var done = copyBtn.dataset.copied || 'Copied';

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          copyBtn.textContent = done;
          setTimeout(function () { copyBtn.textContent = idle; }, 2000);
        }, function () {
          copyBtn.textContent = idle;
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    // Console helper for testing: bbhReset() brings every ball back.
    window.bbhReset = function () {
      var w = root();
      if (w) { try { localStorage.removeItem(w.dataset.bbhKey); } catch (e) {} }
      document.documentElement.classList.remove('bbh-claimed');
      console.log('Beach ball hunt reset. Reload the page.');
    };

    anchor();
    document.addEventListener('DOMContentLoaded', anchor);
    document.addEventListener('shopify:section:load', anchor);

    if ('MutationObserver' in window) {
      var pending;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(anchor, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
